<template>
  <v-container fluid class="pa-5">
    <v-overlay :value="isLoading" absolute>
      <div class="d-flex flex-column align-center justify-center">
        <v-progress-circular indeterminate size="64" :width="5" />
        <span class="my-4">กำลังโหลดข้อมูล</span>
      </div>
    </v-overlay>

    <template v-if="!isLoading">
      <template v-if="sellers.length === 0">
        <v-card class="card-container d-flex pa-6" elevation="0">
          <v-row>
            <v-col cols="12">
              <span class="title-text">จัดการผู้ขาย</span>
            </v-col>

            <v-col
              cols="12"
              class="d-flex flex-column align-center justify-center"
              style="min-height: 88vh"
            >
              <div class="d-flex flex-column align-center">
                <v-img>
                  <img
                    src="@/assets/not_exist_search.svg"
                    alt="no-data"
                    width="103"
                    height="103"
                  />
                </v-img>
                <span class="no-data-text mb-4"> ยังไม่มีรายการผู้ขาย </span>

                <v-btn
                  color="#3b82f6"
                  dark
                  class="create-btn elevation-0 mt-2"
                  @click="goToCreateSeller"
                >
                  <v-icon left size="24">mdi-plus</v-icon>
                  เพิ่มผู้ขาย
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </template>

      <template v-else>
        <v-card class="card-container pa-2" elevation="0">
          <v-card-title>
            <v-row>
              <v-col
                cols="12"
                md="6"
                class="d-flex align-center justify-center justify-md-start"
              >
                <span class="title-text">จัดการผู้ขาย</span>
              </v-col>

              <v-col
                cols="12"
                md="6"
                class="d-flex align-center justify-center justify-md-end"
              >
                <v-btn
                  color="#3b82f6"
                  dark
                  class="create-btn elevation-0"
                  @click="goToCreateSeller"
                >
                  <v-icon left size="24">mdi-plus</v-icon>
                  เพิ่มผู้ขาย
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <Card
                  :sellers-data="sellers"
                  :selected-card-index="selectedCardIndex"
                  @select-card="onSelectCard"
                />
              </v-col>

              <v-col cols="12">
                <Select
                  :search="search"
                  :selected-status="selectedStatus"
                  :selected-product-status="selectedProductStatus"
                  :date-range="dateRange"
                  @update:search="search = $event"
                  @update:selected-status="selectedStatus = $event"
                  @update:selected-product-status="
                    selectedProductStatus = $event
                  "
                  @update:date-range="dateRange = $event"
                />
              </v-col>

              <v-col cols="12">
                <template v-if="filteredSellers.length > 0">
                  <Table
                    :sellers="filteredSellers"
                    :user-role="$store.getters.role"
                    @view="openSellerDetail"
                    @approve="openApproveDialog"
                    @reject="openRejectDialog"
                    @toggle-suspend="toggleSuspendSeller"
                  />
                </template>

                <template v-else>
                  <v-row>
                    <v-col
                      cols="12"
                      class="d-flex flex-column align-center justify-center"
                      style="min-height: 45vh"
                    >
                      <div class="d-flex flex-column align-center">
                        <v-img>
                          <img
                            src="@/assets/not_exist_search.svg"
                            alt="no-data"
                            width="103.8"
                            height="103.8"
                          />
                        </v-img>
                        <span class="no-data-text mb-4">
                          ไม่พบข้อมูลที่ค้นหา กรุณาลองใหม่อีกครั้ง
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>
    </template>
    <!-- Detail Dialog -->
    <v-dialog v-model="detailDialog" max-width="800px">
      <v-card class="pa-4" v-if="selectedSeller">
        <v-card-title class="headline d-flex justify-space-between align-center">
          <span class="title-text">รายละเอียดผู้ขาย: {{ selectedSeller.shopName }}</span>
          <v-btn icon @click="detailDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="mt-4">
          <v-row>
            <v-col cols="12" md="6">
              <div class="mb-4">
                <div class="subtitle-2 font-weight-bold grey--text text--darken-1">ข้อมูลร้านค้า</div>
                <div class="body-1 mt-1">{{ selectedSeller.shopName || '-' }}</div>
              </div>
              <div class="mb-4">
                <div class="subtitle-2 font-weight-bold grey--text text--darken-1">ชื่อผู้ขาย</div>
                <div class="body-1 mt-1">{{ formatSellerName(selectedSeller) }}</div>
              </div>
              <div class="mb-4">
                <div class="subtitle-2 font-weight-bold grey--text text--darken-1">อีเมล</div>
                <div class="body-1 mt-1">{{ selectedSeller.email || '-' }}</div>
              </div>
              <div class="mb-4">
                <div class="subtitle-2 font-weight-bold grey--text text--darken-1">เบอร์โทรศัพท์</div>
                <div class="body-1 mt-1">{{ selectedSeller.phone || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="mb-4">
                <div class="subtitle-2 font-weight-bold grey--text text--darken-1">รหัสประจำตัวประชาชน</div>
                <div class="body-1 mt-1">{{ selectedSeller.personalInfo?.nationalId || '-' }}</div>
              </div>
              <div class="mb-4">
                <div class="subtitle-2 font-weight-bold grey--text text--darken-1">ธนาคาร</div>
                <div class="body-1 mt-1">{{ selectedSeller.bank?.bankName || '-' }}</div>
              </div>
              <div class="mb-4">
                <div class="subtitle-2 font-weight-bold grey--text text--darken-1">เลขบัญชี</div>
                <div class="body-1 mt-1">{{ selectedSeller.bank?.bankAccountNumber || '-' }}</div>
              </div>
              <div class="mb-4">
                <div class="subtitle-2 font-weight-bold grey--text text--darken-1">สถานะปัจจุบัน</div>
                <v-chip
                  small
                  :color="getAccountStatusDisplay(selectedSeller).color"
                  :text-color="getAccountStatusDisplay(selectedSeller).text"
                  class="mt-1"
                >
                  <v-icon left small v-if="getAccountStatusDisplay(selectedSeller).icon">
                    {{ getAccountStatusDisplay(selectedSeller).icon }}
                  </v-icon>
                  {{ getAccountStatusDisplay(selectedSeller).label }}
                </v-chip>
              </div>
            </v-col>

            <v-col cols="12">
              <v-divider class="my-4"></v-divider>
              <div class="subtitle-2 font-weight-bold grey--text text--darken-1 mb-3">เอกสารประกอบการลงทะเบียน</div>

              <div v-if="isLoadingDetail" class="d-flex align-center justify-center py-6">
                <v-progress-circular indeterminate size="32" color="primary" class="mr-3" />
                <span class="body-2 grey--text">กำลังโหลดเอกสาร...</span>
              </div>

              <template v-else-if="selectedSeller.documents && selectedSeller.documents.length">
                <v-row>
                  <v-col v-for="doc in selectedSeller.documents" :key="doc.id" cols="12" sm="6" md="4">
                    <v-card outlined class="pa-2 text-center" style="cursor:pointer"
                      @click="isPdf(doc.filePath) ? openPdf(doc.filePath) : viewImage(doc.filePath)">
                      <div class="d-flex align-center justify-space-between mb-1 px-1">
                        <span class="caption grey--text font-weight-bold">{{ formatDocType(doc.documentType) }}</span>
                        <v-chip x-small :color="getDocStatusDisplay(doc.status).color" :text-color="getDocStatusDisplay(doc.status).text">
                          {{ getDocStatusDisplay(doc.status).label }}
                        </v-chip>
                      </div>
                      <template v-if="isPdf(doc.filePath)">
                        <div class="grey lighten-4 rounded d-flex align-center justify-center" style="height:120px">
                          <v-icon color="red darken-2" size="56">mdi-file-pdf-box</v-icon>
                        </div>
                        <div class="caption primary--text mt-2">คลิกเพื่อเปิด PDF</div>
                      </template>
                      <template v-else>
                        <v-img
                          :src="getFullImageUrl(doc.filePath)"
                          height="120"
                          contain
                          class="grey lighten-4 rounded"
                        >
                          <template v-slot:placeholder>
                            <v-row class="fill-height ma-0" align="center" justify="center">
                              <v-icon color="grey lighten-2" size="48">mdi-image</v-icon>
                            </v-row>
                          </template>
                        </v-img>
                        <div class="caption primary--text mt-2">คลิกเพื่อดูรูปขยาย</div>
                      </template>
                    </v-card>
                  </v-col>
                </v-row>
              </template>

              <div v-else class="body-2 grey--text py-2">ไม่มีเอกสารแนบ</div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn outlined height="40" class="rounded-lg px-6" @click="detailDialog = false">ปิด</v-btn>
          <template v-if="selectedSeller.status === 'inactive'">
            <v-btn
              color="#EE2526"
              dark
              depressed
              height="40"
              class="rounded-lg px-6 ml-2"
              @click="openRejectDialog(selectedSeller)"
            >
              <v-icon left>mdi-close-circle-outline</v-icon>
              ปฏิเสธ
            </v-btn>
            <v-btn
              color="#10B981"
              dark
              depressed
              height="40"
              class="rounded-lg px-6 ml-2"
              @click="openApproveDialog(selectedSeller)"
            >
              <v-icon left>mdi-check-decagram</v-icon>
              อนุมัติร้านค้า
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Approve Dialog -->
    <ApproveDialog
      v-model="approveDialog"
      :seller="approvingSeller"
      :saving="savingApprove"
      @confirm="confirmApprove"
    />

    <!-- Reject Dialog -->
    <RejectDialog
      v-model="rejectDialog"
      :seller="rejectingSeller"
      :saving="savingReject"
      @confirm="confirmReject"
    />

    <!-- Image View Dialog -->
    <v-dialog v-model="imageDialog" max-width="90vw">
      <v-card flat class="transparent">
        <div class="text-right pa-2">
          <v-btn icon color="white" large @click="imageDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-img :src="viewingImageUrl" contain max-height="85vh"></v-img>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Card from "@/components/AdminSellerManagement/Card.vue";
import Select from "@/components/AdminSellerManagement/Select.vue";
import Table from "@/components/AdminSellerManagement/Table.vue";
import ApproveDialog from "@/components/AdminSellerManagement/ApproveDialog.vue";
import RejectDialog from "@/components/AdminSellerManagement/RejectDialog.vue";
import {
  getSellerListApi,
  getSellerByIdApi,
  updateSellerStatusApi,
  approveSellerApi,
  rejectSellerApi,
} from "@/services/api/sellerServices";
import swalAlert from "@/services/alert/swalServices";

export default {
  name: "AdminSellerManagement",

  components: {
    Card,
    Select,
    Table,
    ApproveDialog,
    RejectDialog,
  },

  data() {
    return {
      isLoading: false,
      sellers: [],
      selectedCardIndex: 0,
      search: "",
      selectedStatus: "all",
      selectedProductStatus: "all",
      dateRange: [],

      // Detail Dialog
      detailDialog: false,
      selectedSeller: null,
      isLoadingDetail: false,
      imageDialog: false,
      viewingImageUrl: "",

      // Approve / Reject dialogs
      approveDialog: false,
      rejectDialog: false,
      approvingSeller: null,
      rejectingSeller: null,
      savingApprove: false,
      savingReject: false,
    };
  },

  async created() {
    await this.loadSellers();
  },

  computed: {
    filteredSellers() {
      let result = [...this.sellers];
      const normalizeStatus = (status) => {
        const v = (status || "").toString().trim().toLowerCase();
        if (v === "active") return "active";
        if (v === "inactive") return "inactive";
        if (["suspended", "ban", "banned"].includes(v)) return "suspended";
        if (v === "rejected") return "rejected";
        return "unknown";
      };

      const getActiveProductCount = (seller) => {
        const count =
          seller.activeProductsCount ??
          seller.active_products_count ??
          seller.activeProducts ??
          seller.active_products ??
          seller.productCount ??
          seller.products_count ??
          0;

        const num = Number(count);
        return Number.isNaN(num) ? 0 : num;
      };

      if (this.selectedCardIndex === 1) {
        result = result.filter((s) => getActiveProductCount(s) > 0);
      } else if (this.selectedCardIndex === 2) {
        result = result.filter((s) => getActiveProductCount(s) === 0);
      }

      if (this.selectedStatus && this.selectedStatus !== "all") {
        const targetStatus = this.selectedStatus;
        result = result.filter(
          (s) => normalizeStatus(s.status) === targetStatus
        );
      }

      if (this.selectedProductStatus && this.selectedProductStatus !== "all") {
        if (this.selectedProductStatus === "has_product") {
          result = result.filter((s) => getActiveProductCount(s) > 0);
        } else if (this.selectedProductStatus === "no_product") {
          result = result.filter((s) => getActiveProductCount(s) === 0);
        }
      }

      if ((this.search || "").trim()) {
        const kw = this.search.toLowerCase().trim();

        result = result.filter((s) => {
          const user = s.user || {};
          const first =
            user.firstName ||
            user.firstname ||
            s.firstName ||
            s.firstname ||
            "";
          const last =
            user.lastName || user.lastname || s.lastName || s.lastname || "";
          const fullName = [first, last]
            .map((x) => (x || "").trim())
            .filter(Boolean)
            .join(" ")
            .toLowerCase();

          const shopName =
            (
              s.shopName ||
              s.shop_name ||
              s.storeName ||
              s.store_name ||
              s.brandName ||
              s.brand_name ||
              ""
            ).toLowerCase();

          const email =
            (
              user.email ||
              s.email ||
              s.contactEmail ||
              s.contact_email ||
              ""
            ).toLowerCase();

          return (
            fullName.includes(kw) ||
            shopName.includes(kw) ||
            email.includes(kw)
          );
        });
      }

      if (this.dateRange && this.dateRange.length === 2) {
        const [startRaw, endRaw] = this.dateRange;

        const startStr = new Date(startRaw).toISOString().slice(0, 10);
        const endStr = new Date(endRaw).toISOString().slice(0, 10);

        const [minStr, maxStr] =
          startStr <= endStr ? [startStr, endStr] : [endStr, startStr];

        result = result.filter((s) => {
          if (!s.createdAt) return false;
          const created = new Date(s.createdAt);
          if (isNaN(created)) return false;

          const createdStr = created.toISOString().slice(0, 10);
          return createdStr >= minStr && createdStr <= maxStr;
        });
      }

      return result;
    },
  },

  methods: {
    async loadSellers() {
      this.isLoading = true;
      try {
        const data = await getSellerListApi();
        this.sellers = Array.isArray(data.sellers) ? data.sellers : [];
      } catch (err) {
        console.error("[AdminSellerManagement] loadSellers error:", err);
        this.sellers = [];
      } finally {
        this.isLoading = false;
      }
    },

    onSelectCard(index) {
      this.selectedCardIndex = index;
    },

    goToCreateSeller() {
      this.$router.push({ name: "admin_seller_create" });
    },

    async openSellerDetail(seller) {
      this.selectedSeller = seller;
      this.detailDialog = true;
      this.isLoadingDetail = true;
      try {
        const data = await getSellerByIdApi(seller.id);
        this.selectedSeller = data.seller || seller;
      } catch (err) {
        console.error("[AdminSellerManagement] openSellerDetail error:", err);
      } finally {
        this.isLoadingDetail = false;
      }
    },

    formatSellerName(item) {
      if (!item) return "-";
      const user = item.user || {};
      const personal = item.personalInfo || {};
      const prefix = (personal.prefix || user.prefix || "").trim();
      const first = (personal.firstName || user.firstName || "").trim();
      const last = (personal.lastName || user.lastName || "").trim();
      const parts = [prefix, first, last].filter(Boolean);
      return parts.length ? parts.join(" ") : (user.username || "-");
    },

    formatDocType(type) {
      const dict = {
        bank_book: "หน้าสมุดบัญชี",
        id_card: "บัตรประชาชน",
        business_license: "ใบอนุญาตประกอบธุรกิจ",
        store_photo: "รูปร้านค้า",
        half_body_photo: "รูปครึ่งตัว",
        full_body_photo: "รูปเต็มตัว",
      };
      return dict[type] || type;
    },

    getDocStatusDisplay(status) {
      if (status === "approved") return { label: "อนุมัติแล้ว", color: "#E1FAE8", text: "#0FAE63" };
      if (status === "rejected") return { label: "ปฏิเสธแล้ว", color: "#FDECEC", text: "#E11D48" };
      return { label: "รอตรวจสอบ", color: "#F3F4F6", text: "#6B717F" };
    },

    getFullImageUrl(path) {
      if (!path) return "";
      if (path.startsWith("http")) return path;
      const base = (process.env.VUE_APP_API_URL || "").replace(/\/$/, "");
      return base + (path.startsWith("/") ? path : `/${path}`);
    },

    isPdf(path) {
      return (path || "").toLowerCase().endsWith(".pdf");
    },

    openPdf(path) {
      window.open(this.getFullImageUrl(path), "_blank");
    },

    viewImage(path) {
      this.viewingImageUrl = this.getFullImageUrl(path);
      this.imageDialog = true;
    },

    getAccountStatusDisplay(item) {
      if (!item) return {};
      const s = this.normalizeStatus(item.status);
      if (s === "active") {
        return { label: "ใช้งานปกติ", color: "#E1FAE8", text: "#0FAE63", icon: "mdi-check-circle-outline" };
      }
      if (s === "inactive") {
        return { label: "รออนุมัติ", color: "#FEF3C7", text: "#D97706", icon: "mdi-clock-outline" };
      }
      if (s === "suspended") {
        return { label: "ถูกระงับ", color: "#FDECEC", text: "#E11D48", icon: "mdi-block-helper" };
      }
      if (s === "rejected") {
        return { label: "ถูกปฏิเสธ", color: "#FDECEC", text: "#E11D48", icon: "mdi-close-circle-outline" };
      }
      return { label: "ไม่ทราบสถานะ", color: "#E5E7EB", text: "#4B5563" };
    },

    normalizeStatus(status) {
      const v = (status || "").toString().trim().toLowerCase();
      if (v === "active") return "active";
      if (v === "inactive") return "inactive";
      if (["suspended", "ban", "banned"].includes(v)) return "suspended";
      if (v === "rejected") return "rejected";
      return "unknown";
    },

    openApproveDialog(seller) {
      this.approvingSeller = seller;
      this.approveDialog = true;
    },

    openRejectDialog(seller) {
      this.rejectingSeller = seller;
      this.rejectDialog = true;
    },

    async confirmApprove() {
      this.savingApprove = true;
      try {
        await approveSellerApi(this.approvingSeller.id);
        swalAlert.Success("อนุมัติสำเร็จ", "ร้านค้าเปิดใช้งานแล้ว");
        this.approveDialog = false;
        this.detailDialog = false;
        await this.loadSellers();
      } catch (err) {
        console.error("Approve error", err);
        swalAlert.Error("เกิดข้อผิดพลาด", err?.response?.data?.message || "ไม่สามารถอนุมัติได้");
      } finally {
        this.savingApprove = false;
      }
    },

    async confirmReject({ rejectReason }) {
      this.savingReject = true;
      try {
        await rejectSellerApi(this.rejectingSeller.id, rejectReason);
        swalAlert.Success("ปฏิเสธสำเร็จ", "ปฏิเสธร้านค้าเรียบร้อยแล้ว");
        this.rejectDialog = false;
        this.detailDialog = false;
        await this.loadSellers();
      } catch (err) {
        console.error("Reject error", err);
        swalAlert.Error("เกิดข้อผิดพลาด", err?.response?.data?.message || "ไม่สามารถปฏิเสธได้");
      } finally {
        this.savingReject = false;
      }
    },

    async toggleSuspendSeller(seller) {
      const sellerId = seller?.id;
      if (!sellerId) return;
      const normalized = (seller?.status || "").toString().trim().toLowerCase();
      const isSuspended = normalized === "suspended";
      const newStatus = isSuspended ? "active" : "suspended";
      try {
        await updateSellerStatusApi(sellerId, newStatus);
        await this.loadSellers();
      } catch (err) {
        console.error("[AdminSellerManagement] toggleSuspendSeller error:", err);
        const msg =
          err?.response?.data?.message || "เปลี่ยนสถานะผู้ขายไม่สำเร็จ";
        await swalAlert.Error("เกิดข้อผิดพลาด", msg);
      }
    },
  },
};
</script>

<style scoped>
.title-text {
  font-size: 24px;
  font-weight: 700;
  color: #1f2a39;
}
.no-data-text {
  font-size: 14px;
  font-weight: 400;
  color: #6b717f;
}
.card-container {
  border-radius: 16px !important;
  box-shadow: 0 0 2px 0 #1018280d !important;
}
.create-btn {
  font-size: 16px !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  height: 40px !important;
  text-transform: none !important;
}

@media (max-width: 960px) {
  .create-btn {
    width: 100% !important;
  }
}
</style>